export default __webpack_public_path__ + "static/media/img-egt-du3@2x.defe9817.png";